import { CSS } from "@dnd-kit/utilities";

export const LAYER_LIST_SCROLL_ATTR = "data-layer-list-scroll";

export const layerListAutoScroll = {
  threshold: {
    x: 0.2,
    y: 0.2,
  },
  acceleration: 10,
  interval: 5,
  layoutShiftCompensation: false,
  canScroll: (element) =>
    Boolean(element?.hasAttribute?.(LAYER_LIST_SCROLL_ATTR)),
};

export const sortableLayerRowStyle = ({
  transform,
  transition,
  isDragging,
}) => ({
  transform: isDragging ? undefined : CSS.Transform.toString(transform),
  transition: isDragging ? undefined : transition,
});
